export var SupportedLanguages;
(function (SupportedLanguages) {
    SupportedLanguages["FI_FI"] = "fi-FI";
    SupportedLanguages["SV_FI"] = "sv-FI";
})(SupportedLanguages || (SupportedLanguages = {}));
export function getAlternativeLocales(TkrConfig) {
    return TkrConfig.availableLocales.filter(l => l !== TkrConfig.defaultLocale);
}
